import { useMemo } from 'react';
import { useUrlParams } from '@/contexts/UrlParamsContext';

/**
 * URL 参数映射关系
 */
const PARAM_MAPPING = {
  utm_term: 'keyword',
  gclid: 'gclid',
  utm_creative: 'creative',
  utm_campaign: 'campaignid'
};

/**
 * useAffiliateLink Hook
 * 自动替换 affiliate 链接中的 URL 参数占位符
 *
 * @param {string} originalLink - 原始的 affiliate 链接（包含占位符）
 * @returns {string} 替换后的链接
 *
 * @example
 * const link = useAffiliateLink(product.affiliateLink);
 * // 原始: https://example.com?utm_term={keyword}&gclid={gclid}
 * // 返回: https://example.com?utm_term=888&gclid=abc
 */
export const useAffiliateLink = (originalLink) => {
  const { params } = useUrlParams();

  // 使用 useMemo 缓存结果，依赖 originalLink 和 params
  const replacedLink = useMemo(() => {
    if (!originalLink || typeof originalLink !== 'string') {
      return originalLink;
    }

    let result = originalLink;

    // 遍历参数映射，替换占位符
    Object.entries(PARAM_MAPPING).forEach(([urlParam, placeholder]) => {
      const value = params[urlParam] || '';
      const placeholderPattern = new RegExp(`\\{${placeholder}\\}`, 'g');
      result = result.replace(placeholderPattern, value);
    });

    console.log('[useAffiliateLink] Original:', originalLink);
    console.log('[useAffiliateLink] Params:', params);
    console.log('[useAffiliateLink] Replaced:', result);

    return result;
  }, [originalLink, params]);

  return replacedLink;
};

